import axios from "axios";
import { API_URL } from "../../utils/api-utils";
import { common } from "../../utils";
//Master
export const GetListTopicTypeMaster = async (param) => {
  let url = `${API_URL.Loader}/api/master/GetListTopicTypeMaster`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DeleteTopicType = async (param) => {
  let url = `${API_URL.Loader}/api/master/DeleteTopicType`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveTopicType = async (param) => {
    let url = `${API_URL.Loader}/api/master/SaveTopicType`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data;
  };

  

  